import { Col, Form, Input, Row } from 'antd';

import { ExtraFiltersProps } from '@/types/ExtraFiltersProps';

import AppPageHeader from '@/components/_common/AppPageHeader';

import { ListSuppliersQuery } from '@/core/domain/people/Suppliers/Suppliers.types';
import { useIntl } from 'react-intl';

const SelectPartReplacementFilters: React.FC<
  ExtraFiltersProps<ListSuppliersQuery>
> = ({ setQueryParams }) => {
  const intl = useIntl();

  return (
    <AppPageHeader
      onSearch={(value: string) =>
        setQueryParams((prev) => ({ ...prev, search: value }))
      }
      extraFilters={
        <Form>
          <Row gutter={[24, 24]}>
            <Col xs={24} md={12} xl={6}>
              <Input
                name="manufacturingCode"
                onChange={({ target: { value } }) =>
                  setQueryParams((prev) => ({
                    ...prev,
                    manufacturingCode: value,
                  }))
                }
                placeholder={intl.formatMessage({
                  id: 'parts.partsReplacement.filters.manufacturingCode',
                })}
              />
            </Col>

            <Col xs={24} md={12} xl={6}>
              <Input
                name="barCode"
                onChange={({ target: { value } }) =>
                  setQueryParams((prev) => ({ ...prev, barCode: value }))
                }
                placeholder={intl.formatMessage({
                  id: 'parts.partsReplacement.filters.barCode',
                })}
              />
            </Col>

            <Col xs={24} md={12} xl={6}>
              <Input
                name="sku"
                onChange={({ target: { value } }) =>
                  setQueryParams((prev) => ({ ...prev, sku: value }))
                }
                placeholder={intl.formatMessage({
                  id: 'parts.partsReplacement.filters.internalCode',
                })}
              />
            </Col>

            <Col xs={24} md={12} xl={6}>
              <Input
                name="companyCode"
                onChange={({ target: { value } }) =>
                  setQueryParams((prev) => ({ ...prev, companyCode: value }))
                }
                placeholder={intl.formatMessage({
                  id: 'parts.partsReplacement.filters.companyCode',
                })}
              />
            </Col>
          </Row>
        </Form>
      }
    />
  );
};

export default SelectPartReplacementFilters;
